import { CalendarToday, Close } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  ApprovalMemberName,
  ApprovalTypeLabel,
  Caveat,
  Container,
  Headline,
  RemoveApprovalButton,
  RoundRobinDate,
  RoundRobinDateContainer,
} from "./styles";

export type ApprovalType =
  | "APPROVED"
  | "ROUND_ROBIN_APPROVED"
  | "REPPROVED"
  | "COMMENT";

export interface IApprover {
  memberName?: string;
  approvalId: string;
  caveat?: string;
  roundRobinDate?: string;
  type: ApprovalType;
}

interface IApproverCardProps {
  approver: IApprover;
  isRemovable?: boolean;
  onRemove?: () => void;
}

const APPROVER_LABELS = {
  APPROVED: "forms.minutes.actions.approvedBy",
  ROUND_ROBIN_APPROVED: "forms.minutes.actions.roudRobbinapproved",
  REPPROVED: "forms.minutes.actions.repprovedBy",
  COMMENT: "forms.minutes.actions.caveats",
};

const ApproverCard = ({
  approver,
  isRemovable = false,
  onRemove,
}: IApproverCardProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      {approver.type !== "COMMENT" && (
        <Headline>
          <ApprovalTypeLabel type={approver.type}>
            {`${t(APPROVER_LABELS[approver.type])}: `}
          </ApprovalTypeLabel>

          <ApprovalMemberName>{approver.memberName}</ApprovalMemberName>
        </Headline>
      )}

      {approver.caveat && (
        <Caveat>
          <b>{`${t("forms.minutes.actions.caveats")}: `}</b>
          {approver.caveat}
        </Caveat>
      )}

      {approver.type === "ROUND_ROBIN_APPROVED" && (
        <RoundRobinDateContainer>
          <RoundRobinDate>{approver.roundRobinDate}</RoundRobinDate>
          <CalendarToday style={{ width: "20px" }} />
        </RoundRobinDateContainer>
      )}

      {isRemovable && (
        <RemoveApprovalButton
          onClick={() => {
            if (onRemove) {
              onRemove();
            }
          }}
        >
          <Close />
        </RemoveApprovalButton>
      )}
    </Container>
  );
};

export default ApproverCard;
